import classNames from 'classnames'
import React from 'react'

import HeroCTA, { CTAAction } from './HeroCTA'

import './RichHero.scss'

const RichHero = ({
  children,
  ctaAction,
  ctaAction2,
  ctaCustomLink,
  ctaCustomText,
  ctaSearchParams,
  heading,
  isMegaHero,
  isWideLeftGutter,
  leadText,
  leadTextPosition = 'after',
  trailingContent,
}: {
  children: React.ReactNode
  ctaAction: CTAAction
  ctaAction2?: CTAAction
  ctaCustomLink?: string
  ctaCustomText?: string
  ctaSearchParams?: string
  heading: string
  isMegaHero?: boolean
  isWideLeftGutter?: boolean
  leadText: React.ReactNode
  leadTextPosition?: 'before' | 'after'
  trailingContent?: React.ReactNode
}) => {
  return (
    <div className="richHero gutter gutter--center">
      <div className="richHero__columns">
        <div className="richHero__content">
          <div
            className={classNames('richHero__leftGutter', {
              'richHero__leftGutter--wide': isWideLeftGutter,
            })}
          >
            {leadTextPosition === 'before' && (
              <div className="richText richHero__leadText--before">
                {leadText}
              </div>
            )}
            <h1
              className={classNames('richHero__heading', {
                'richHero__heading--huge': isMegaHero,
              })}
            >
              {heading}
            </h1>
            {leadTextPosition === 'after' && (
              <div className="richText richHero__leadText">{leadText}</div>
            )}
          </div>
          <HeroCTA
            ctaAction={ctaAction}
            ctaAction2={ctaAction2}
            ctaCustomLink={ctaCustomLink}
            ctaCustomText={ctaCustomText}
            ctaSearchParams={ctaSearchParams}
          />
        </div>
        <div className="richHero__graphics">{children}</div>
      </div>
      {trailingContent && (
        <div className="richHero__trailer">{trailingContent}</div>
      )}
    </div>
  )
}

export default RichHero
